export const refs = {
  headerForm: document.querySelector('.header-form'),
  taskList: document.querySelector('.tasks-list'),
};
